import React from 'react';
import PropTypes from 'prop-types';

import {
  ErrorTag,
  InfoTag,
  OkTag,
  WarningTag,
} from '../../../../components/Tags';
import { DeployDisplayStatus } from '../../../utils/webflowDeployer';
import texts from '../texts.json';

const TAG_BY_STATUS = {
  [DeployDisplayStatus.PENDING]: InfoTag,
  [DeployDisplayStatus.IN_PROGRESS]: InfoTag,
  [DeployDisplayStatus.COMPLETED]: OkTag,
  [DeployDisplayStatus.FAILED]: ErrorTag,
  [DeployDisplayStatus.TIMED_OUT]: WarningTag,
};

const DeployStatusTag = ({ status }) => {
  const Tag = TAG_BY_STATUS[status] || InfoTag;
  return <Tag>{texts.status[status] || status}</Tag>;
};

DeployStatusTag.propTypes = {
  status: PropTypes.string.isRequired,
};

export default DeployStatusTag;
